import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Modal, Button } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { useOutletContext } from 'react-router-dom';
//api
import { getAllListsNotPaginated } from 'api/lists';
//constants
import { getKeyword } from 'constants';
// custom-hooks
import useAssignedLibrary from 'utils/customHooks/useAssignedLibrary';
// components
import CustomInput from 'components/backoffice/customInput';
import { SelectInputCustom } from 'components/input';

const MenuModal = ({
  show,
  onHide,
  editedItem,
  setEditedItem,
  handleEditItem
}) => {
  const { t } = useTranslation(['backoffice']);
  const { setTitle } = useOutletContext()
  const KeywordsChoice = getKeyword(t);
  const [lists, setLists] = useState([]);
  const { assignedLibrary } = useAssignedLibrary();

  const getAllLists = async () => {
    const { data, status } = await getAllListsNotPaginated();
    if (status === 200 && data.length > 0) {
      const customList = data.map((list) => {
        return {
          value: list.nombre,
          id: list.id
        }
      })
      setLists([...customList]);
    } else {
      setLists([]);
    }
  };

  useEffect(() => {
    getAllLists();
  }, []);

  useEffect(() => {
    if (show) {
      setTitle(editedItem?.text)
    }
    return () => {
      setTitle('');
    };
  }, [show, editedItem])


  return (
    <Modal className="modal-backoffice" show={show} onHide={onHide}>
      <Modal.Header closeButton>
        <Modal.Title>{`${t('editar')}`}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <CustomInput
          label={`${t('titulo')}`}
          type="text"
          value={editedItem.text}
          onChange={(value) => setEditedItem({ ...editedItem, text: value })}
        />
        {typeof editedItem.url === 'object' ? <SelectInputCustom
          label={t('listas')}
          value={editedItem.url.id ? editedItem.url.id : editedItem.url.state.list}
          onCheckedItem={(value) => setEditedItem({
            ...editedItem, url: {
              id: value,
              name: lists.find(list => list.id === parseInt(value)).value,
              pathname: `/${assignedLibrary}/lista/products_by_list`,
              search: `?title=${encodeURIComponent(lists.find(list => list.id === parseInt(value)).value)}`,
              state: { list: value }
            }
          })}
          placeholder={t('select')}
          choices={lists}
        /> :
          !editedItem.keyword && <CustomInput
            label={`${t('url')}`}
            placeholder={`${t('pathToResource')}`}
            type="text"
            value={editedItem.url}
            onChange={(value) => setEditedItem({ ...editedItem, url: value })}
          />}
        {editedItem.keyword && <SelectInputCustom
          label={t('predefinedPages')}
          value={editedItem.keyword}
          onCheckedItem={(value) => setEditedItem({ ...editedItem, keyword: value })}
          placeholder={t('select')}
          choices={KeywordsChoice}
        />}
      </Modal.Body>
      <Modal.Footer>
        <Button className="btn-intra bg-terciary-color btn btn-primary" onClick={onHide}>
          {`${t('cancel')}`}
        </Button>
        <Button className="btn-intra bg-primary-color btn btn-primary" onClick={handleEditItem}>
          {`${t('editar')}`}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

MenuModal.propTypes = {
  show: PropTypes.bool,
  onHide: PropTypes.func,
  editedItem: PropTypes.object,
  setEditedItem: PropTypes.func,
  handleEditItem: PropTypes.func
};

export default MenuModal;
